import { format } from 'date-fns';
import { TZDate } from '@date-fns/tz';

export const isWithinTimeRange = ({ from, to }: {
	from?: number
	to?: number
}): boolean => {
	if (from === undefined && to === undefined) {
		return false;
	}
	
	const currentTime = new Date().getTime();
	const isAlreadyBegin = !from || from <= currentTime;
	const isStillInTheRange = !to || currentTime <= to;
	return isAlreadyBegin && isStillInTheRange;
};

export function parseDuration(totalSeconds: number) {
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;
	return { hours, minutes, seconds };
};


export const formatDateTimeWithTz = (date: Date, timeZone: string): string => {
	const tzDate = new TZDate(date, timeZone);
	const formattedDateTime = format(tzDate, 'yyyy-MM-dd\'T\'HH:mm:ssxxx');
	return `${formattedDateTime} (${timeZone})`;
};

export const formatDateTimeWithLocalTz = (date: Date): string => {
	const timeZone = typeof window !== 'undefined'
		? Intl.DateTimeFormat().resolvedOptions().timeZone
		: 'UTC';
	return formatDateTimeWithTz(date, timeZone);
};